import { generateMutations } from '../builder'

export default {
  ...generateMutations('getAdaptationKinds', 'adaptationKinds'),
}
